import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const GenReview = () => {

    const { sha } = useParams();

    const [genReview, setGenReview] = useState({
        owner: "",
        name: "",
        message: "",
        file: "",
        genReviews: [],
    });
    const [models, setModels] = useState([]);
    const [prompts, setPrompts] = useState([]);
    const [genReviews, setGenReviews] = useState([]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_generated_review/' + sha, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setGenReview(data);

                const distinctModels = new Set();
                const distinctPrompts = new Set();

                data.genReviews.forEach(e => {
                    distinctModels.add(e.model);
                    distinctPrompts.add(e.prompt);
                });

                setModels(Array.from(distinctModels));
                setPrompts(Array.from(distinctPrompts));

                let evals = {};
                data.genReviews.forEach(e => {
                    if (!evals[e.model]) {
                        evals[e.model] = {};
                    }
                    evals[e.model][e.prompt] = {
                        review: e.review,
                        eval: e.eval
                    }
                });
                setGenReviews(evals);

            })
            .catch(error => {
                console.error("Error fetching generated review:", error);
            });
    }, [sha]);

    useEffect(() => {
        if (Object.keys(genReviews).length > 0) {
            models.forEach((model) => {
                prompts.forEach((prompt) => {
                    const evalData = genReviews[model][prompt]?.eval;
                    if (evalData) {
                        document.getElementById(`${model}---${prompt}---Coherent`).value = evalData.coherent ? "true" : "false";
                        document.getElementById(`${model}---${prompt}---Vulnerability`).value = evalData.vulnerability ? "true" : "false";
                        document.getElementById(`${model}---${prompt}---Plausible`).value = evalData.plausible ? "true" : "false";
                    }
                });
            });
        }
    }, [genReviews, models, prompts]);

    


    function eval_genReviews() {

        let filled = true;

        models.forEach((model) => {
            prompts.forEach((prompt) => {
                let coherent = document.getElementById(`${model}---${prompt}---Coherent`).value;
                let vulnerability = document.getElementById(`${model}---${prompt}---Vulnerability`).value;
                let plausible = document.getElementById(`${model}---${prompt}---Plausible`).value;

                if (coherent === 'Select' || vulnerability === 'Select' || plausible === 'Select') {
                    filled = false;
                }

            });
        });

        if (!filled) {
            alert('Please fill all fields');
            return;
        }

        let evals = {};
        models.forEach((model) => {
            evals[model] = {};
            prompts.forEach((prompt) => {
                evals[model][prompt] = {
                    eval: {
                        coherent: document.getElementById(`${model}---${prompt}---Coherent`).value,
                        vulnerability: document.getElementById(`${model}---${prompt}---Vulnerability`).value,
                        plausible: document.getElementById(`${model}---${prompt}---Plausible`).value
                    }
                };
            });
        });

        fetch(process.env.REACT_APP_BACKEND_URL + 'eval_ds_generated_review', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
                sha: sha,
                evals: evals
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.res === 'ok') {
                    alert('Generated Reviews evaluated');
                } else {
                    alert('Error evaluating generated reviews');
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });

    }


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Generated Review</h1>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12 grid md:grid-cols-2 gap-4 sm:grid-cols-1">
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Repository:</h1>
                    <p>{genReview.owner}/{genReview.name}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL:</h1>
                    <Link target="_blank" to={'https://github.com/' + genReview.owner + '/' + genReview.name + '/commit/' + sha}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{genReview.owner}/{genReview.name}/commit/{sha}
                        </p>
                    </Link>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Evaluation:</h1>
                </div>
                <div className="grid md:grid-cols-3 gap-4 sm:grid-cols-1">
                    {prompts.map((prompt, index) => (
                        <div key={index} className="col-span-1 break-words">
                            <label className="text-base font-semibold leading-7 text-gray-900">{prompt}</label>
                        </div>
                    ))}
                    {models.map((model) =>
                        prompts.map((prompt) => (
                            <div key={`${model}---${prompt}`} className="col-span-1 break-words">
                                <label className="text-base font-semibold leading-7 text-gray-900">{model}</label>
                                {/* Scrollable review section */}
                                <div className="max-h-40 overflow-y-auto bg-gray-50 rounded-md p-2 mt-2 border border-gray-200">
                                    <p>{genReviews[model][prompt].review}</p>
                                </div>

                                <div className="relative inline-block">
                                    <label
                                        className="text-base font-semibold leading-7 text-gray-900 cursor-pointer"
                                        onMouseEnter={() => {
                                            const tooltip = document.getElementById(`${model}---${prompt}---Coherent-tooltip`);
                                            if (tooltip) tooltip.style.display = "block";
                                        }}
                                        onMouseLeave={() => {
                                            const tooltip = document.getElementById(`${model}---${prompt}---Coherent-tooltip`);
                                            if (tooltip) tooltip.style.display = "none";
                                        }}
                                    >
                                        Coherent:
                                    </label>
                                    <div
                                        id={`${model}---${prompt}---Coherent-tooltip`}
                                        style={{ display: "none" }}
                                        className="absolute left-full top-0 ml-2 z-10 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg"
                                    >
                                        A generated review is coherent if it is logically consistent, grammatically correct, and understandable.
                                    </div>
                                </div>
                                <select className="w-full mb-2" id={`${model}---${prompt}---Coherent`}>
                                    <option value="Select">Select</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>

                                <div className="relative inline-block">
                                    <label
                                        className="text-base font-semibold leading-7 text-gray-900 cursor-pointer"
                                        onMouseEnter={() => {
                                            const tooltip = document.getElementById(`${model}---${prompt}---Vulnerability-tooltip`);
                                            if (tooltip) tooltip.style.display = "block";
                                        }}
                                        onMouseLeave={() => {
                                            const tooltip = document.getElementById(`${model}---${prompt}---Vulnerability-tooltip`);
                                            if (tooltip) tooltip.style.display = "none";
                                        }}
                                    >
                                        Vulnerability:
                                    </label>
                                    <div
                                        id={`${model}---${prompt}---Vulnerability-tooltip`}
                                        style={{ display: "none" }}
                                        className="absolute left-full top-0 ml-2 z-10 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg"
                                    >
                                        A review is security-relevant if it specifically identifies or comments on the security flaw that the commit fixes.
                                    </div>
                                </div>
                                <select className="w-full mb-2" id={`${model}---${prompt}---Vulnerability`}>
                                    <option value="Select">Select</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>

                                <div className="relative inline-block">
                                    <label
                                        className="text-base font-semibold leading-7 text-gray-900 cursor-pointer"
                                        onMouseEnter={() => {
                                            const tooltip = document.getElementById(`${model}---${prompt}---Plausible-tooltip`);
                                            if (tooltip) tooltip.style.display = "block";
                                        }}
                                        onMouseLeave={() => {
                                            const tooltip = document.getElementById(`${model}---${prompt}---Plausible-tooltip`);
                                            if (tooltip) tooltip.style.display = "none";
                                        }}
                                    >
                                        Plausible:
                                    </label>
                                    <div
                                        id={`${model}---${prompt}---Plausible-tooltip`}
                                        style={{ display: "none" }}
                                        className="absolute left-full top-0 ml-2 z-10 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg"
                                    >
                                        A review is plausible if it could reasonably have been written by a human reviewer before the commit, in a way that would prompt the developer to make the corresponding fix. NO HALLUCINATIONS
                                    </div>
                                </div>
                                <select className="w-full mb-2" id={`${model}---${prompt}---Plausible`}>
                                    <option value="Select">Select</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>

                            </div>
                        ))
                    )}
                </div>

                <div className="mt-4 flex grid justify-items-end gap">
                <button onClick={eval_genReviews}
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Evaluate
                </button>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96 bg-gray-50 relative">
                    {/* Copy Button */}
                    <button
                        onClick={() => {
                            const textToCopy = `Message:\n${genReview.message}\n\nFile Diff:\n${genReview.file}`;
                            navigator.clipboard.writeText(textToCopy)
                                .catch(err => console.error('Failed to copy: ', err));
                        }}
                        className="absolute top-2 right-2 rounded-md bg-gray-800 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-800"
                    >
                        Copy
                    </button>

                    {/* Message and Diff */}
                    <h1 className="text-base font-semibold leading-7 text-gray-900 mt-6">Message:</h1>
                    <p>{genReview.message}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">File Diff:</h1>
                    <pre className="text-sm whitespace-pre-wrap text-left">{genReview.file}</pre>
                </div>
            </div>
        </>
    );
}

export default GenReview;